export default class List
{
    constructor(options)
    {
        if(!options.url)
            console.error('TableList没有定义url');
        this.source.url = options.url;
        if(options.pageSize)
            this.pageSize = options.pageSize;
        if(options.searchForm)
            this.searchForm = options.searchForm;
    }
    searchForm = {};
    source = {
        url: null
    };
    data = [];
    count = 0;
    pageSize = 20;
    page = 1;
    loading = false;
    load()
    {
        this.loading = true;
        return Fx.Http.post(this.source.url, {...this.searchForm, pageSize: this.pageSize, page: this.page}).
        then((resp)=>
        {
            this.loading = false;
            console.log(resp);
            if(resp.isSuccess())
            {
                this.data = resp.getData('dataList');
                this.count = resp.getData('count');
            }
            else
            {
                Fx.$globalVue.$message.error(resp.getErrorMessage());
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/table/List.js